import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿En qué se diferencia de "Códigos Ocultos"?',
    a: 'Aquél es para detectar y leer; este es para proyectar e influir. Son las dos caras de la misma moneda.'
  }, {
    q: '¿Es difícil de aprender?',
    a: 'Está diseñado en fichas técnicas de paso a paso. Si podés leer, podés aplicarlo.'
  }, {
    q: '¿Sirve para videollamadas?',
    a: 'Totalmente. Los marcos mentales funcionan igual en presencial que en digital.'
  }, {
    q: '¿Acceso inmediato?',
    a: 'Sí, recibís todo en tu mail en PDF ni bien se confirma el pago.'
  }];
  return <SectionWrapper className="bg-bg" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <h2 className="font-heading text-3xl font-black text-text-primary uppercase tracking-tight mb-10 text-center" data-id="element-34">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, idx) => <div key={idx} className="border-b border-border overflow-hidden" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-37">
                <span className="font-heading font-bold text-lg text-text-primary group-hover:text-accent transition-colors" data-id="element-38">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="text-text-secondary group-hover:text-accent ml-4 shrink-0" data-id="element-39">
                  <ChevronDown className="w-5 h-5" data-id="element-40" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-41">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-42">
                    <div className="pb-6 font-body text-text-secondary leading-relaxed pr-8" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}